import { render, staticRenderFns } from "./triangle-in-shield.vue?vue&type=template&id=27ab45f1&scoped=true&"
import script from "./triangle-in-shield.vue?vue&type=script&lang=js&"
export * from "./triangle-in-shield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ab45f1",
  null
  
)

export default component.exports